import React from 'react';
import { FiShield, FiCompass, FiLock, FiStar, FiMonitor, FiZap } from "react-icons/fi";

const badges = [
    { icon: <FiShield className="w-4 h-4" />, text: "PSRA Licensed" },
    { icon: <FiCompass className="w-4 h-4" />, text: "Nairobi • Kisumu • Mombasa • Nakuru • Eldoret" },
    { icon: <FiMonitor className="w-4 h-4" />, text: "24/7 Control Room" },
    { icon: <FiZap className="w-4 h-4" />, text: "Quick Response Unit" },
    { icon: <FiStar className="w-4 h-4" />, text: "85% Guard Retention" },
];

function InfiniteMarquee() {
    return (
        <div className="w-full py-5 bg-base-100 border-b border-zinc-200 overflow-hidden">
            <style>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .marquee-track {
                    animation: marquee 30s linear infinite;
                }
                .marquee-track:hover {
                    animation-play-state: paused;
                }
            `}</style>

            <div className="relative">
                {/* Fade edges */}
                <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-base-100 to-transparent z-10"></div>
                <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-base-100 to-transparent z-10"></div>

                {/* Scrolling track — duplicated for seamless loop */}
                <div className="marquee-track flex items-center gap-12 w-max">
                    {[...badges, ...badges].map((badge, idx) => (
                        <div key={idx} className="flex items-center gap-3 shrink-0">
                            <span className="text-[#FFC000]">{badge.icon}</span>
                            <span className="text-xs font-bold uppercase tracking-widest text-zinc-500 whitespace-nowrap">
                                {badge.text}
                            </span>
                            <span className="w-1 h-1 rounded-full bg-zinc-300 ml-6"></span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default InfiniteMarquee;